import { Paragraph } from '@quickmd-llc/design-system';
import { useApplicationStore } from '@data';

export function SelectVisitSection() {
  const visit = useApplicationStore((state) => state.visit);

  return (
    <div>
      <Paragraph size="xs" className="mb-1 font-semibold">
        Selected Visit
      </Paragraph>

      {visit && (
        <pre className="w-full break-words rounded bg-shade-90 p-2 text-gray-100">
          <code className="font-mono w-full whitespace-break-spaces text-xs">
            {JSON.stringify(visit)}
          </code>
        </pre>
      )}

      {!visit && <Paragraph size="xs">No visit selected</Paragraph>}
    </div>
  );
}
